export const messagingEndpoints = {
  smsSend: "/sms/send",
  smsSchedule: "/sms/schedule",
  smsSendToGroup: "/sms/send-to-group",
  smsReports: "/sms/reports",
  smsReportsDownload: "/sms/reports/download",
  callsInitiate: "/calls/initiate",
  callsSchedule: "/calls/schedule",
  callsInitiateToGroup: "/calls/initiate-to-group",
  callsScheduleToGroup: "/calls/schedule-to-group",
  callsReports: "/calls/reports",
  callsResend: "/calls/resend",
  senderId: "/sender-id",
  balance: "/balance",
  balanceTransactions: "/balance/transactions",
  balanceTopUp: "/balance/top-up",
  fileUpload: "/files/upload",
  apiKeys: "/api-keys",
  smsRates: "/sms/estimate",
  callsEstimate: "/calls/estimate",
  smsResendByCampaign: "/sms/resend-by-campaign",
  callsResendByCampaign: "/calls/resend-by-campaign",
  // priceSchedule: "/price_schedule",
  priceSchedule: "/sms/send",
  weatherCost: "/weather/cost",
  weatherSchedule: "/weather/schedule",
  weatherCampaigns: "/weather/reports/campaigns",
  weatherReports: "/weather/reports",
  weatherCampaignSummary: (id) => `/weather/reports/${id}/summary`,
};

export const peopleEndpoints = {
  groupPersons: (groupId) => `/groups/${groupId}/persons`,
  groupPerson: (groupId, personId) => `/groups/${groupId}/persons/${personId}`,
  contacts: "/groups",
  fileUpload: "/person-uploads",
  personUploads: "/person-uploads",
};

export const contentEndpoints = {
  commodities: "/commodities",
  markets: "/markets",
};
